import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import unsplash from "../api/unsplash";
import { DataGrid,itIT } from '@mui/x-data-grid';
import {IconButton} from '@mui/material';
import FileUploader from "./FileUploader";
import {Download,RemoveRedEye,Delete} from '@mui/icons-material';

const ext ={doc:"application/msword",
dot  :"application/msword",
docx :"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
dotx :"application/vnd.openxmlformats-officedocument.wordprocessingml.template",
docm :"application/vnd.ms-word.document.macroEnabled.12",
dotm :"application/vnd.ms-word.template.macroEnabled.12",
xls  :"application/vnd.ms-excel",
xlt  :"application/vnd.ms-excel",
xla  :"application/vnd.ms-excel",
xlsx :"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
xltx :"application/vnd.openxmlformats-officedocument.spreadsheetml.template",
xlsm :"application/vnd.ms-excel.sheet.macroEnabled.12",
xltm :"application/vnd.ms-excel.template.macroEnabled.12",
xlam :"application/vnd.ms-excel.addin.macroEnabled.12",
xlsb :"application/vnd.ms-excel.sheet.binary.macroEnabled.12",
ppt  :"application/vnd.ms-powerpoint",
pot  :"application/vnd.ms-powerpoint",
pps  :"application/vnd.ms-powerpoint",
ppa  :"application/vnd.ms-powerpoint",
pptx :"application/vnd.openxmlformats-officedocument.presentationml.presentation",
potx :"application/vnd.openxmlformats-officedocument.presentationml.template",
ppsx :"application/vnd.openxmlformats-officedocument.presentationml.slideshow",
ppam :"application/vnd.ms-powerpoint.addin.macroEnabled.12",
pptm :"application/vnd.ms-powerpoint.presentation.macroEnabled.12",
potm :"application/vnd.ms-powerpoint.template.macroEnabled.12",
ppsm :"application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
mdb  :"application/vnd.ms-access",
pdf:"application/pdf"}

const Allegati = (props) =>{
const [allegati,setAllegati] = useState();
const navigate = useNavigate();



const downloadFile = async(id,estensione,descrizione,operazione) => {
  await unsplash.post('ftp', {file :id+estensione,nomeOriginale:descrizione.includes(estensione)?(descrizione):(descrizione+estensione),operazione: "download"},
  {headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}`
  }})

  await unsplash
  .get('ftp',{ headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }, responseType: 'blob',
  params:{nomeOriginale:descrizione.includes(estensione)?(descrizione):(descrizione+estensione)}}
   ).then(response => {
      console.log(response);
      const url = window.URL.createObjectURL(new Blob([response.data], {type: ext[estensione.replace(".","")]})); //prendo il file, lo rendo blob lo aggancio a un link e scarico
    
      const link = document.createElement('a');
      link.href = url;
      if(operazione==="download"){
      link.setAttribute('download', descrizione+estensione);
      document.body.appendChild(link);
      link.click();
    }
    if(operazione==="visualizza"){
      var win = window.open();
win.document.write('<iframe width="560" height="315" src="https://docs.google.com/gview?url='+url+'&embedded=true" frameborder="0" allowfullscreen></iframe>')

    } 
    })
      

}



const columns = [
  

  { field: 'Descrizione', headerName: 'Descrizione', width: 300 },
  { field: 'Estensione', headerName: 'Estensione', width: 200 },
  { field: 'ID', headerName: '', hide: true, width :"130"},
  { field: "Azioni", headerName: 'Azioni', hide: false, width :"200",
  renderCell: (params) => ( //mi aiuta a mettere il valore
  <>
  <IconButton aria-label="edit" onClick={() => downloadFile(params.row.ID,params.row.Estensione,params.row.Descrizione,"download")}>
  <Download 
  style={{height:"2rem",width:"2rem",color:"#2264ae"}}
 
    />
</IconButton>
  <IconButton aria-label="edit" onClick={() => downloadFile(params.row.ID,params.row.Estensione,params.row.Descrizione,"visualizza")}>
  <RemoveRedEye 
  style={{height:"2rem",width:"2rem",color:"#2264ae"}}
 
    />
</IconButton>
<IconButton aria-label="edit" onClick={() => {navigate("/dettaglioLavoratore", {state: {lavoratore: params.row}})}}>
  <Delete 
  style={{height:"2rem",width:"2rem",color:"red"}}
 
    />
</IconButton>
</>

  )



}
];


useEffect( async () => {

  
        let responseAziendali =  await unsplash
          .get('allegati',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{colonna:"Cliente",ID:props.idAzienda}}
           );
     
           console.log(responseAziendali.data);
           setAllegati(responseAziendali.data.data);


},[]);





    return <div>


 {
allegati === undefined?
"":<>
<FileUploader></FileUploader>
  
<div style={{ height: 400, width: '100%' }}>
<DataGrid

      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      rows={allegati}
      getRowId={allegati => allegati.ID}
      columns={columns}
      disableSelectionOnClick 
    />
    

    </div>
    </>
/*lavoratori?.map(lavoratore =>
  
  
  
  <p>{lavoratore.Nome} {lavoratore.Cognome} </p>)*/


 }
    </div>

}

export default Allegati